{
    "v": "5.12.1",
    "fr": 60,
    "ip": 0,
    "op": 3000,
    "w": 1080,
    "h": 1920,
    "nm": "2025-08-18_PressAndBooks-SelfCheckout_All",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Group",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [540, 657, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [50, 50, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [21.66, 6.769],
                                                [0, 17.599],
                                                [11.507, 9.025],
                                                [19.404, 0],
                                                [0, 0],
                                                [0, 0],
                                                [8.348, -0.226],
                                                [0, 0],
                                                [2.031, -8.574],
                                                [13.538, -6.318],
                                                [12.861, -9.251],
                                                [-2.031, -17.373],
                                                [-16.696, 1.354],
                                                [2.031, 8.348],
                                                [0, 0],
                                                [4.738, -0.226],
                                                [4.061, 6.092],
                                                [0.677, 8.799],
                                                [-8.574, 8.574],
                                                [-12.635, 0],
                                                [0.902, -34.972],
                                                [12.409, -12.184],
                                                [18.501, 0.226],
                                                [12.409, 13.989],
                                                [-0.226, 16.471],
                                                [-10.83, 12.409],
                                                [-14.214, 2.933],
                                                [0, 0],
                                                [0.226, 12.635],
                                                [-12.635, -0.451],
                                                [0, -25.947],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [12.184, -0.451],
                                                [0, -18.276],
                                                [0, -0.677],
                                                [6.769, 5.641],
                                                [20.983, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-9.251, 4.061],
                                                [0, -6.543],
                                                [-46.028, -0.677],
                                                [-16.696, 13.989],
                                                [-4.287, 8.574],
                                                [0, 0],
                                                [0, 0],
                                                [-13.086, 10.153],
                                                [0, 16.019]
                                            ],
                                            "o": [
                                                [14.214, -7.671],
                                                [0, -13.989],
                                                [-11.507, -8.799],
                                                [0, 0],
                                                [0, 0],
                                                [-3.159, -9.025],
                                                [0, 0],
                                                [7.22, -0.226],
                                                [-2.482, 11.056],
                                                [-24.593, 11.507],
                                                [-17.148, 12.409],
                                                [2.256, 20.983],
                                                [9.702, -0.677],
                                                [0, 0],
                                                [0.451, 4.287],
                                                [-7.22, 0.451],
                                                [-4.061, -6.543],
                                                [-1.354, -13.086],
                                                [7.671, -7.897],
                                                [25.496, 0],
                                                [-0.451, 17.373],
                                                [-11.507, 10.83],
                                                [-19.178, -0.451],
                                                [-11.507, -12.861],
                                                [0, -14.666],
                                                [8.799, -9.928],
                                                [0, 0],
                                                [-11.507, -2.708],
                                                [-0.226, -17.599],
                                                [16.922, 0.451],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-7.671, -6.318],
                                                [-24.142, 0.677],
                                                [0, 0.677],
                                                [-2.708, -8.348],
                                                [-11.056, -9.251],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [13.086, 0],
                                                [-2.256, 6.092],
                                                [0, 43.546],
                                                [20.983, 0.226],
                                                [7.446, -6.318],
                                                [0, 0],
                                                [0, 0],
                                                [23.465, 0],
                                                [11.958, -9.251],
                                                [0.226, -20.532]
                                            ],
                                            "v": [
                                                [150.716, -5.869],
                                                [172.376, -44.902],
                                                [154.326, -82.13],
                                                [109.652, -93.637],
                                                [56.856, -93.637],
                                                [56.856, -79.423],
                                                [36.324, -92.96],
                                                [36.324, -88.222],
                                                [44.446, -72.428],
                                                [17.371, -46.256],
                                                [-29.107, -23.242],
                                                [-51.896, 23.688],
                                                [-18.503, 57.306],
                                                [-1.356, 41.738],
                                                [-6.094, 41.738],
                                                [-13.314, 49.184],
                                                [-31.589, 38.579],
                                                [-38.584, 17.371],
                                                [-28.205, -15.345],
                                                [3.383, -28.206],
                                                [48.733, 27.749],
                                                [29.781, 74.454],
                                                [-17.375, 92.053],
                                                [-66.11, 70.618],
                                                [-81.678, 26.17],
                                                [-67.013, -14.894],
                                                [-32.041, -34.974],
                                                [-32.041, -39.261],
                                                [-53.024, -64.08],
                                                [-28.205, -90.253],
                                                [3.157, -49.189],
                                                [8.121, -49.189],
                                                [8.121, -98.15],
                                                [3.157, -98.15],
                                                [3.157, -87.094],
                                                [-28.431, -96.57],
                                                [-68.141, -60.921],
                                                [-68.141, -58.891],
                                                [-82.355, -80.325],
                                                [-127.706, -93.637],
                                                [-182.533, -93.637],
                                                [-182.533, 92.278],
                                                [-155.909, 92.278],
                                                [-155.909, 11.956],
                                                [-128.157, 11.956],
                                                [-94.99, 6.541],
                                                [-98.375, 25.493],
                                                [-20.082, 98.145],
                                                [39.483, 77.161],
                                                [57.307, 54.824],
                                                [57.307, 92.504],
                                                [114.842, 92.504],
                                                [164.705, 79.192],
                                                [182.529, 38.354]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [4.289, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-5.641, -3.61],
                                                [4.061, -2.482],
                                                [0, 4.513],
                                                [0.451, 2.031]
                                            ],
                                            "o": [
                                                [-4.287, 1.579],
                                                [0.902, -4.061],
                                                [0, -2.256],
                                                [2.256, 5.189]
                                            ],
                                            "v": [
                                                [6.318, 3.384],
                                                [-6.318, 9.702],
                                                [-4.964, -3.159],
                                                [-5.415, -9.702]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [-56.858, -37.682],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [5.415, -4.513],
                                                [13.312, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-5.641, -5.189],
                                                [0, -8.799]
                                            ],
                                            "o": [
                                                [-5.866, 4.964],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [11.056, 0],
                                                [5.189, 4.738],
                                                [0.226, 10.379]
                                            ],
                                            "v": [
                                                [22.67, 21.773],
                                                [-3.277, 28.767],
                                                [-31.48, 28.767],
                                                [-31.48, -28.767],
                                                [-0.795, -28.767],
                                                [23.122, -21.322],
                                                [31.47, -0.338]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [-120.818, -40.954],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 3",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 3,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [-6.318, -4.738],
                                                [0, -7.446],
                                                [5.866, -4.061],
                                                [11.056, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [11.056, 0],
                                                [6.092, 4.513],
                                                [0, 9.702],
                                                [-6.317, 5.189],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-30.685, -27.075],
                                                [-2.708, -27.075],
                                                [21.434, -20.758],
                                                [30.685, -0.903],
                                                [21.66, 20.532],
                                                [-4.061, 27.075],
                                                [-30.685, 27.075]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [118.228, -42.646],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 4",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [22.563, 0.226],
                                                [-13.763, 7.897],
                                                [-2.256, 6.769],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [7.671, -3.61],
                                                [7.897, -4.513],
                                                [0, 0],
                                                [-9.702, -16.696]
                                            ],
                                            "v": [
                                                [-25.496, 1.467],
                                                [10.379, -12.973],
                                                [25.496, -28.542],
                                                [25.496, 28.542]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [35.423, -35.764],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 5",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 5,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [6.543, -5.415],
                                                [12.635, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-6.543, -4.287],
                                                [0, -9.476]
                                            ],
                                            "o": [
                                                [-6.543, 5.415],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [12.184, 0],
                                                [7.671, 4.964],
                                                [0.226, 9.702]
                                            ],
                                            "v": [
                                                [26.504, 21.886],
                                                [-1.022, 29.557],
                                                [-35.543, 29.557],
                                                [-35.543, -29.557],
                                                [-2.601, -29.557],
                                                [23.797, -23.916],
                                                [35.53, -1.354]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [123.085, 38.128],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 6",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 6,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "mm",
                            "mm": 5,
                            "nm": "Merge Paths 1",
                            "mn": "ADBE Vector Filter - Merge",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 8,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "rc",
                                    "d": 1,
                                    "s": {
                                        "a": 0,
                                        "k": [43.997, 43.997],
                                        "ix": 2
                                    },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 4 },
                                    "nm": "Rectangle Path 1",
                                    "mn": "ADBE Vector Shape - Rect",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [-501.002, 70.505],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 180, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "rc",
                                    "d": 1,
                                    "s": {
                                        "a": 0,
                                        "k": [43.997, 43.997],
                                        "ix": 2
                                    },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 4 },
                                    "nm": "Rectangle Path 1",
                                    "mn": "ADBE Vector Shape - Rect",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [-418.423, 70.505],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 180, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "rc",
                                    "d": 1,
                                    "s": {
                                        "a": 0,
                                        "k": [43.997, 43.997],
                                        "ix": 2
                                    },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 4 },
                                    "nm": "Rectangle Path 1",
                                    "mn": "ADBE Vector Shape - Rect",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [-335.844, 70.505],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 180, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 3",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 3,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "rc",
                                    "d": 1,
                                    "s": {
                                        "a": 0,
                                        "k": [43.997, 43.997],
                                        "ix": 2
                                    },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 4 },
                                    "nm": "Rectangle Path 1",
                                    "mn": "ADBE Vector Shape - Rect",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [-253.265, 70.505],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 180, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 4",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 4,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "rc",
                                    "d": 1,
                                    "s": {
                                        "a": 0,
                                        "k": [43.997, 43.997],
                                        "ix": 2
                                    },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 4 },
                                    "nm": "Rectangle Path 1",
                                    "mn": "ADBE Vector Shape - Rect",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [250.331, -70.511],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 180, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 5",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 5,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "rc",
                                    "d": 1,
                                    "s": {
                                        "a": 0,
                                        "k": [43.997, 43.997],
                                        "ix": 2
                                    },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 4 },
                                    "nm": "Rectangle Path 1",
                                    "mn": "ADBE Vector Shape - Rect",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [332.91, -70.511],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 180, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 6",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 6,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "rc",
                                    "d": 1,
                                    "s": {
                                        "a": 0,
                                        "k": [43.997, 43.997],
                                        "ix": 2
                                    },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 4 },
                                    "nm": "Rectangle Path 1",
                                    "mn": "ADBE Vector Shape - Rect",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [415.489, -70.511],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 180, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 7",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 7,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "rc",
                                    "d": 1,
                                    "s": {
                                        "a": 0,
                                        "k": [43.997, 43.997],
                                        "ix": 2
                                    },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 4 },
                                    "nm": "Rectangle Path 1",
                                    "mn": "ADBE Vector Shape - Rect",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [498.068, -70.511],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 180, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 8",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 8,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [3.836, 1.805],
                                                        [0, 0],
                                                        [-3.384, -1.354],
                                                        [-2.256, 0],
                                                        [-1.579, 1.128],
                                                        [0, 1.579],
                                                        [1.128, 1.128],
                                                        [3.384, 2.031],
                                                        [2.256, 2.708],
                                                        [0, 3.159],
                                                        [-3.384, 2.708],
                                                        [-5.189, 0],
                                                        [-5.641, -2.933],
                                                        [0, 0],
                                                        [4.061, 0],
                                                        [1.354, -0.903],
                                                        [0, -1.579],
                                                        [-1.128, -1.128],
                                                        [-2.933, -1.579],
                                                        [0, 0],
                                                        [0, -6.318],
                                                        [3.384, -2.933],
                                                        [5.415, 0],
                                                        [2.707, 0.677]
                                                    ],
                                                    "o": [
                                                        [0, 0],
                                                        [3.159, 2.031],
                                                        [3.159, 1.354],
                                                        [2.256, 0],
                                                        [1.579, -1.128],
                                                        [0, -1.579],
                                                        [-1.128, -1.128],
                                                        [-6.994, -3.836],
                                                        [-2.256, -2.708],
                                                        [0, -4.287],
                                                        [3.384, -2.708],
                                                        [5.415, 0],
                                                        [0, 0],
                                                        [-6.317, -3.836],
                                                        [-2.031, 0],
                                                        [-1.354, 0.903],
                                                        [0, 1.354],
                                                        [1.128, 1.128],
                                                        [0, 0],
                                                        [9.025, 5.189],
                                                        [0, 4.513],
                                                        [-3.61, 2.933],
                                                        [-3.159, 0],
                                                        [-2.708, -0.226]
                                                    ],
                                                    "v": [
                                                        [-18.614, 23.803],
                                                        [-18.614, 12.071],
                                                        [-9.138, 17.26],
                                                        [-1.015, 19.291],
                                                        [4.851, 17.712],
                                                        [7.333, 13.65],
                                                        [5.753, 9.589],
                                                        [-1.015, 5.077],
                                                        [-14.779, -4.851],
                                                        [-17.937, -13.876],
                                                        [-12.973, -24.255],
                                                        [-0.338, -28.316],
                                                        [16.132, -23.803],
                                                        [16.132, -13.199],
                                                        [0.338, -19.065],
                                                        [-4.851, -17.712],
                                                        [-6.882, -14.102],
                                                        [-5.077, -10.492],
                                                        [1.015, -6.43],
                                                        [4.851, -4.174],
                                                        [18.614, 12.973],
                                                        [13.425, 24.029],
                                                        [-0.113, 28.316],
                                                        [-8.912, 27.188]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [1, 1, 1, 1],
                                                "ix": 4
                                            },
                                            "o": { "a": 0, "k": 100, "ix": 5 },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [504.386, 64.865],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [100, 100],
                                                "ix": 3
                                            },
                                            "r": { "a": 0, "k": 0, "ix": 6 },
                                            "o": { "a": 0, "k": 100, "ix": 7 },
                                            "sk": { "a": 0, "k": 0, "ix": 4 },
                                            "sa": { "a": 0, "k": 0, "ix": 5 },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 1",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ty": "rc",
                                                    "d": 1,
                                                    "s": {
                                                        "a": 0,
                                                        "k": [10.83, 83.256],
                                                        "ix": 2
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "nm": "Rectangle Path 1",
                                                    "mn": "ADBE Vector Shape - Rect",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [432.524, 51.102],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 180,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 1",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 1,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ind": 0,
                                                    "ty": "sh",
                                                    "ix": 1,
                                                    "ks": {
                                                        "a": 0,
                                                        "k": {
                                                            "i": [
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0]
                                                            ],
                                                            "o": [
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0]
                                                            ],
                                                            "v": [
                                                                [
                                                                    3.384,
                                                                    -27.413
                                                                ],
                                                                [
                                                                    16.245,
                                                                    -27.413
                                                                ],
                                                                [-7.22, -0.564],
                                                                [
                                                                    20.983,
                                                                    27.413
                                                                ],
                                                                [6.543, 27.413],
                                                                [
                                                                    -20.983,
                                                                    -0.564
                                                                ]
                                                            ],
                                                            "c": true
                                                        },
                                                        "ix": 2
                                                    },
                                                    "nm": "Path 1",
                                                    "mn": "ADBE Vector Shape - Group",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [459.373, 65.316],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 2",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 2,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "mm",
                                            "mm": 5,
                                            "nm": "Merge Paths 1",
                                            "mn": "ADBE Vector Filter - Merge",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [1, 1, 1, 1],
                                                "ix": 4
                                            },
                                            "o": { "a": 0, "k": 100, "ix": 5 },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [100, 100],
                                                "ix": 3
                                            },
                                            "r": { "a": 0, "k": 0, "ix": 6 },
                                            "o": { "a": 0, "k": 100, "ix": 7 },
                                            "sk": { "a": 0, "k": 0, "ix": 4 },
                                            "sa": { "a": 0, "k": 0, "ix": 5 },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 2",
                                    "np": 4,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 2,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ind": 0,
                                                    "ty": "sh",
                                                    "ix": 1,
                                                    "ks": {
                                                        "a": 0,
                                                        "k": {
                                                            "i": [
                                                                [-8.574, 0],
                                                                [
                                                                    -5.415,
                                                                    -5.415
                                                                ],
                                                                [0, -8.123],
                                                                [5.641, -5.189],
                                                                [8.574, 0],
                                                                [5.415, 5.189],
                                                                [0, 7.897],
                                                                [-5.641, 5.415]
                                                            ],
                                                            "o": [
                                                                [8.348, 0],
                                                                [5.415, 5.415],
                                                                [0, 7.897],
                                                                [-5.641, 5.189],
                                                                [-8.123, 0],
                                                                [
                                                                    -5.415,
                                                                    -5.189
                                                                ],
                                                                [0, -8.123],
                                                                [5.415, -5.415]
                                                            ],
                                                            "v": [
                                                                [
                                                                    0.113,
                                                                    -27.978
                                                                ],
                                                                [
                                                                    20.87,
                                                                    -19.855
                                                                ],
                                                                [29.219, 0.451],
                                                                [20.87, 20.081],
                                                                [
                                                                    -0.338,
                                                                    27.978
                                                                ],
                                                                [
                                                                    -20.87,
                                                                    20.081
                                                                ],
                                                                [
                                                                    -29.219,
                                                                    0.226
                                                                ],
                                                                [
                                                                    -20.87,
                                                                    -19.855
                                                                ]
                                                            ],
                                                            "c": true
                                                        },
                                                        "ix": 2
                                                    },
                                                    "nm": "Path 1",
                                                    "mn": "ADBE Vector Shape - Group",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [388.866, 65.654],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 1",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 1,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ind": 0,
                                                    "ty": "sh",
                                                    "ix": 1,
                                                    "ks": {
                                                        "a": 0,
                                                        "k": {
                                                            "i": [
                                                                [5.415, 0],
                                                                [3.384, -3.384],
                                                                [0, -5.415],
                                                                [
                                                                    -3.384,
                                                                    -3.384
                                                                ],
                                                                [-5.189, 0],
                                                                [-3.384, 3.384],
                                                                [0, 5.189],
                                                                [3.384, 3.384]
                                                            ],
                                                            "o": [
                                                                [-5.189, 0],
                                                                [-3.384, 3.384],
                                                                [0, 5.189],
                                                                [3.384, 3.384],
                                                                [5.415, 0],
                                                                [3.384, -3.384],
                                                                [0, -5.189],
                                                                [-3.61, -3.61]
                                                            ],
                                                            "v": [
                                                                [
                                                                    -0.451,
                                                                    -18.05
                                                                ],
                                                                [
                                                                    -13.312,
                                                                    -12.861
                                                                ],
                                                                [
                                                                    -18.276,
                                                                    0.226
                                                                ],
                                                                [
                                                                    -13.086,
                                                                    13.086
                                                                ],
                                                                [0, 18.05],
                                                                [
                                                                    13.086,
                                                                    13.086
                                                                ],
                                                                [18.276, 0.226],
                                                                [
                                                                    13.086,
                                                                    -12.635
                                                                ]
                                                            ],
                                                            "c": true
                                                        },
                                                        "ix": 2
                                                    },
                                                    "nm": "Path 1",
                                                    "mn": "ADBE Vector Shape - Group",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [388.753, 65.429],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 2",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 2,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "mm",
                                            "mm": 5,
                                            "nm": "Merge Paths 1",
                                            "mn": "ADBE Vector Filter - Merge",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [1, 1, 1, 1],
                                                "ix": 4
                                            },
                                            "o": { "a": 0, "k": 100, "ix": 5 },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [100, 100],
                                                "ix": 3
                                            },
                                            "r": { "a": 0, "k": 0, "ix": 6 },
                                            "o": { "a": 0, "k": 100, "ix": 7 },
                                            "sk": { "a": 0, "k": 0, "ix": 4 },
                                            "sa": { "a": 0, "k": 0, "ix": 5 },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 3",
                                    "np": 4,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 3,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ind": 0,
                                                    "ty": "sh",
                                                    "ix": 1,
                                                    "ks": {
                                                        "a": 0,
                                                        "k": {
                                                            "i": [
                                                                [-8.348, 0],
                                                                [
                                                                    -5.415,
                                                                    -5.415
                                                                ],
                                                                [0, -8.123],
                                                                [5.641, -5.189],
                                                                [8.574, 0],
                                                                [5.415, 5.189],
                                                                [0, 7.897],
                                                                [-5.641, 5.415]
                                                            ],
                                                            "o": [
                                                                [8.348, 0],
                                                                [5.415, 5.415],
                                                                [0, 7.897],
                                                                [-5.641, 5.189],
                                                                [-8.123, 0],
                                                                [
                                                                    -5.415,
                                                                    -5.189
                                                                ],
                                                                [0, -8.123],
                                                                [5.641, -5.415]
                                                            ],
                                                            "v": [
                                                                [
                                                                    0.113,
                                                                    -27.978
                                                                ],
                                                                [
                                                                    20.87,
                                                                    -19.855
                                                                ],
                                                                [29.219, 0.451],
                                                                [20.87, 20.081],
                                                                [
                                                                    -0.338,
                                                                    27.978
                                                                ],
                                                                [
                                                                    -20.87,
                                                                    20.081
                                                                ],
                                                                [
                                                                    -29.219,
                                                                    0.226
                                                                ],
                                                                [
                                                                    -20.87,
                                                                    -19.855
                                                                ]
                                                            ],
                                                            "c": true
                                                        },
                                                        "ix": 2
                                                    },
                                                    "nm": "Path 1",
                                                    "mn": "ADBE Vector Shape - Group",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [322.532, 65.654],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 1",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 1,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ind": 0,
                                                    "ty": "sh",
                                                    "ix": 1,
                                                    "ks": {
                                                        "a": 0,
                                                        "k": {
                                                            "i": [
                                                                [5.415, 0],
                                                                [3.384, -3.384],
                                                                [0, -5.415],
                                                                [
                                                                    -3.384,
                                                                    -3.384
                                                                ],
                                                                [-5.189, 0],
                                                                [-3.384, 3.384],
                                                                [0, 5.189],
                                                                [3.384, 3.384]
                                                            ],
                                                            "o": [
                                                                [-5.189, 0],
                                                                [-3.384, 3.384],
                                                                [0, 5.189],
                                                                [3.384, 3.384],
                                                                [5.415, 0],
                                                                [3.384, -3.384],
                                                                [0, -5.189],
                                                                [-3.836, -3.61]
                                                            ],
                                                            "v": [
                                                                [
                                                                    -0.451,
                                                                    -18.05
                                                                ],
                                                                [
                                                                    -13.312,
                                                                    -12.861
                                                                ],
                                                                [
                                                                    -18.276,
                                                                    0.226
                                                                ],
                                                                [
                                                                    -13.086,
                                                                    13.086
                                                                ],
                                                                [0, 18.05],
                                                                [
                                                                    13.086,
                                                                    13.086
                                                                ],
                                                                [18.276, 0.226],
                                                                [
                                                                    13.086,
                                                                    -12.635
                                                                ]
                                                            ],
                                                            "c": true
                                                        },
                                                        "ix": 2
                                                    },
                                                    "nm": "Path 1",
                                                    "mn": "ADBE Vector Shape - Group",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [322.644, 65.429],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 2",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 2,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "mm",
                                            "mm": 5,
                                            "nm": "Merge Paths 1",
                                            "mn": "ADBE Vector Filter - Merge",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [1, 1, 1, 1],
                                                "ix": 4
                                            },
                                            "o": { "a": 0, "k": 100, "ix": 5 },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [100, 100],
                                                "ix": 3
                                            },
                                            "r": { "a": 0, "k": 0, "ix": 6 },
                                            "o": { "a": 0, "k": 100, "ix": 7 },
                                            "sk": { "a": 0, "k": 0, "ix": 4 },
                                            "sa": { "a": 0, "k": 0, "ix": 5 },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 4",
                                    "np": 4,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 4,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ind": 0,
                                                    "ty": "sh",
                                                    "ix": 1,
                                                    "ks": {
                                                        "a": 0,
                                                        "k": {
                                                            "i": [
                                                                [6.318, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [
                                                                    -3.836,
                                                                    -1.805
                                                                ],
                                                                [
                                                                    -2.031,
                                                                    -3.384
                                                                ],
                                                                [0, -4.287],
                                                                [8.348, -3.61],
                                                                [-3.61, -3.836],
                                                                [0, -5.415],
                                                                [2.256, -3.159],
                                                                [4.287, -2.031]
                                                            ],
                                                            "o": [
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [6.769, 0],
                                                                [3.836, 1.805],
                                                                [2.031, 3.159],
                                                                [0, 8.123],
                                                                [6.092, 1.128],
                                                                [3.61, 3.836],
                                                                [0, 4.287],
                                                                [-2.256, 3.159],
                                                                [-4.061, 2.256]
                                                            ],
                                                            "v": [
                                                                [
                                                                    -0.226,
                                                                    41.515
                                                                ],
                                                                [
                                                                    -28.429,
                                                                    41.515
                                                                ],
                                                                [
                                                                    -28.429,
                                                                    -41.515
                                                                ],
                                                                [
                                                                    -6.543,
                                                                    -41.515
                                                                ],
                                                                [
                                                                    9.476,
                                                                    -38.808
                                                                ],
                                                                [
                                                                    18.276,
                                                                    -31.136
                                                                ],
                                                                [
                                                                    21.209,
                                                                    -19.855
                                                                ],
                                                                [8.574, -2.256],
                                                                [23.014, 5.189],
                                                                [
                                                                    28.429,
                                                                    18.953
                                                                ],
                                                                [
                                                                    25.044,
                                                                    30.234
                                                                ],
                                                                [15.343, 38.356]
                                                            ],
                                                            "c": true
                                                        },
                                                        "ix": 2
                                                    },
                                                    "nm": "Path 1",
                                                    "mn": "ADBE Vector Shape - Group",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [256.762, 50.989],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 1",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 1,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ind": 0,
                                                    "ty": "sh",
                                                    "ix": 1,
                                                    "ks": {
                                                        "a": 0,
                                                        "k": {
                                                            "i": [
                                                                [10.153, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [-2.708, 2.482],
                                                                [0, 3.836]
                                                            ],
                                                            "o": [
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [6.317, 0],
                                                                [2.708, -2.482],
                                                                [0, -8.123]
                                                            ],
                                                            "v": [
                                                                [
                                                                    -2.595,
                                                                    -12.522
                                                                ],
                                                                [
                                                                    -12.748,
                                                                    -12.522
                                                                ],
                                                                [
                                                                    -12.748,
                                                                    12.522
                                                                ],
                                                                [
                                                                    -4.851,
                                                                    12.522
                                                                ],
                                                                [8.687, 8.912],
                                                                [12.748, -0.564]
                                                            ],
                                                            "c": true
                                                        },
                                                        "ix": 2
                                                    },
                                                    "nm": "Path 1",
                                                    "mn": "ADBE Vector Shape - Group",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [253.039, 32.6],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 2",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 2,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ind": 0,
                                                    "ty": "sh",
                                                    "ix": 1,
                                                    "ks": {
                                                        "a": 0,
                                                        "k": {
                                                            "i": [
                                                                [5.866, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [-2.482, 1.128],
                                                                [-1.354, 2.256],
                                                                [0, 2.482],
                                                                [1.579, 2.031],
                                                                [2.707, 1.128]
                                                            ],
                                                            "o": [
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [6.543, 0],
                                                                [2.256, -0.903],
                                                                [1.354, -2.031],
                                                                [0, -2.482],
                                                                [
                                                                    -1.579,
                                                                    -2.031
                                                                ],
                                                                [-2.933, -0.903]
                                                            ],
                                                            "v": [
                                                                [
                                                                    -5.302,
                                                                    -13.199
                                                                ],
                                                                [
                                                                    -16.358,
                                                                    -13.199
                                                                ],
                                                                [
                                                                    -16.358,
                                                                    13.199
                                                                ],
                                                                [
                                                                    -4.625,
                                                                    13.199
                                                                ],
                                                                [8.687, 11.62],
                                                                [14.327, 6.882],
                                                                [
                                                                    16.358,
                                                                    -0.113
                                                                ],
                                                                [
                                                                    14.102,
                                                                    -7.107
                                                                ],
                                                                [7.784, -11.845]
                                                            ],
                                                            "c": true
                                                        },
                                                        "ix": 2
                                                    },
                                                    "nm": "Path 1",
                                                    "mn": "ADBE Vector Shape - Group",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [256.649, 68.926],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 3",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 3,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "mm",
                                            "mm": 5,
                                            "nm": "Merge Paths 1",
                                            "mn": "ADBE Vector Filter - Merge",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [1, 1, 1, 1],
                                                "ix": 4
                                            },
                                            "o": { "a": 0, "k": 100, "ix": 5 },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [100, 100],
                                                "ix": 3
                                            },
                                            "r": { "a": 0, "k": 0, "ix": 6 },
                                            "o": { "a": 0, "k": 100, "ix": 7 },
                                            "sk": { "a": 0, "k": 0, "ix": 4 },
                                            "sa": { "a": 0, "k": 0, "ix": 5 },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 5",
                                    "np": 5,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 5,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 9",
                            "np": 5,
                            "cix": 2,
                            "bm": 0,
                            "ix": 9,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [3.836, 1.805],
                                                        [0, 0],
                                                        [-3.384, -1.354],
                                                        [-2.256, 0],
                                                        [-1.579, 1.128],
                                                        [0, 1.579],
                                                        [1.128, 1.128],
                                                        [3.384, 2.031],
                                                        [2.256, 2.708],
                                                        [0, 3.159],
                                                        [-3.384, 2.708],
                                                        [-5.189, 0],
                                                        [-5.641, -2.933],
                                                        [0, 0],
                                                        [4.061, 0],
                                                        [1.354, -0.902],
                                                        [0, -1.579],
                                                        [-1.128, -1.128],
                                                        [-2.933, -1.579],
                                                        [0, 0],
                                                        [0, -6.318],
                                                        [3.384, -2.933],
                                                        [5.415, 0],
                                                        [2.708, 0.677]
                                                    ],
                                                    "o": [
                                                        [0, 0],
                                                        [3.159, 2.031],
                                                        [3.159, 1.354],
                                                        [2.256, 0],
                                                        [1.579, -1.128],
                                                        [0, -1.579],
                                                        [-1.128, -1.128],
                                                        [-6.994, -3.836],
                                                        [-2.256, -2.708],
                                                        [0, -4.287],
                                                        [3.384, -2.708],
                                                        [5.415, 0],
                                                        [0, 0],
                                                        [-6.318, -3.836],
                                                        [-2.031, 0],
                                                        [-1.354, 0.903],
                                                        [0, 1.354],
                                                        [1.128, 1.128],
                                                        [0, 0],
                                                        [9.025, 5.189],
                                                        [0, 4.513],
                                                        [-3.61, 2.933],
                                                        [-3.159, 0],
                                                        [-2.707, -0.226]
                                                    ],
                                                    "v": [
                                                        [-18.614, 23.803],
                                                        [-18.614, 12.071],
                                                        [-9.138, 17.26],
                                                        [-1.015, 19.291],
                                                        [4.851, 17.712],
                                                        [7.333, 13.65],
                                                        [5.753, 9.589],
                                                        [-1.015, 5.077],
                                                        [-14.778, -4.851],
                                                        [-17.937, -13.876],
                                                        [-12.973, -24.255],
                                                        [-0.338, -28.316],
                                                        [16.132, -23.803],
                                                        [16.132, -13.199],
                                                        [0.338, -19.065],
                                                        [-4.851, -17.712],
                                                        [-6.882, -14.102],
                                                        [-5.077, -10.492],
                                                        [1.015, -6.43],
                                                        [4.851, -4.174],
                                                        [18.614, 12.973],
                                                        [13.425, 24.029],
                                                        [-0.113, 28.316],
                                                        [-8.912, 27.188]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [1, 1, 1, 1],
                                                "ix": 4
                                            },
                                            "o": { "a": 0, "k": 100, "ix": 5 },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [-294.554, -36.892],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [100, 100],
                                                "ix": 3
                                            },
                                            "r": { "a": 0, "k": 0, "ix": 6 },
                                            "o": { "a": 0, "k": 100, "ix": 7 },
                                            "sk": { "a": 0, "k": 0, "ix": 4 },
                                            "sa": { "a": 0, "k": 0, "ix": 5 },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 1",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 1,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [3.836, 1.805],
                                                        [0, 0],
                                                        [-3.384, -1.354],
                                                        [-2.256, 0],
                                                        [-1.579, 1.128],
                                                        [0, 1.579],
                                                        [1.128, 1.128],
                                                        [3.384, 2.031],
                                                        [2.256, 2.708],
                                                        [0, 3.159],
                                                        [-3.384, 2.708],
                                                        [-5.189, 0],
                                                        [-5.641, -2.933],
                                                        [0, 0],
                                                        [4.061, 0],
                                                        [1.354, -0.902],
                                                        [0, -1.579],
                                                        [-1.128, -1.128],
                                                        [-2.933, -1.579],
                                                        [0, 0],
                                                        [0, -6.318],
                                                        [3.384, -2.933],
                                                        [5.415, 0],
                                                        [2.708, 0.677]
                                                    ],
                                                    "o": [
                                                        [0, 0],
                                                        [3.159, 2.031],
                                                        [3.159, 1.354],
                                                        [2.256, 0],
                                                        [1.579, -1.128],
                                                        [0, -1.579],
                                                        [-1.128, -1.128],
                                                        [-7.22, -3.836],
                                                        [-2.256, -2.708],
                                                        [0, -4.287],
                                                        [3.384, -2.708],
                                                        [5.415, 0],
                                                        [0, 0],
                                                        [-6.318, -3.836],
                                                        [-2.031, 0],
                                                        [-1.354, 0.903],
                                                        [0, 1.354],
                                                        [1.128, 1.128],
                                                        [0, 0],
                                                        [9.025, 5.189],
                                                        [0, 4.513],
                                                        [-3.61, 2.933],
                                                        [-3.159, 0],
                                                        [-2.256, -0.226]
                                                    ],
                                                    "v": [
                                                        [-18.501, 23.803],
                                                        [-18.501, 12.071],
                                                        [-9.025, 17.26],
                                                        [-0.902, 19.291],
                                                        [4.964, 17.712],
                                                        [7.446, 13.65],
                                                        [5.866, 9.589],
                                                        [-0.902, 5.077],
                                                        [-14.891, -4.851],
                                                        [-18.05, -13.876],
                                                        [-13.086, -24.255],
                                                        [-0.451, -28.316],
                                                        [16.019, -23.803],
                                                        [16.019, -13.199],
                                                        [0.226, -19.065],
                                                        [-4.964, -17.712],
                                                        [-6.994, -14.102],
                                                        [-5.189, -10.492],
                                                        [0.902, -6.43],
                                                        [4.738, -4.174],
                                                        [18.501, 12.973],
                                                        [13.312, 24.029],
                                                        [-0.226, 28.316],
                                                        [-9.025, 27.188]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [1, 1, 1, 1],
                                                "ix": 4
                                            },
                                            "o": { "a": 0, "k": 100, "ix": 5 },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [-342.048, -36.892],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [100, 100],
                                                "ix": 3
                                            },
                                            "r": { "a": 0, "k": 0, "ix": 6 },
                                            "o": { "a": 0, "k": 100, "ix": 7 },
                                            "sk": { "a": 0, "k": 0, "ix": 4 },
                                            "sa": { "a": 0, "k": 0, "ix": 5 },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 2",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 2,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ind": 0,
                                                    "ty": "sh",
                                                    "ix": 1,
                                                    "ks": {
                                                        "a": 0,
                                                        "k": {
                                                            "i": [
                                                                [0, 0],
                                                                [0, 0],
                                                                [
                                                                    -3.159,
                                                                    -2.933
                                                                ],
                                                                [-5.189, 0],
                                                                [-6.092, 4.513],
                                                                [0, 0],
                                                                [3.384, -0.902],
                                                                [4.287, 0],
                                                                [3.836, 2.482],
                                                                [2.256, 4.287],
                                                                [0, 5.641],
                                                                [-4.738, 5.189],
                                                                [-7.671, 0],
                                                                [
                                                                    -4.287,
                                                                    -5.189
                                                                ],
                                                                [0, -8.348]
                                                            ],
                                                            "o": [
                                                                [0, 0],
                                                                [0.226, 5.189],
                                                                [3.159, 3.159],
                                                                [7.22, 0],
                                                                [0, 0],
                                                                [-3.384, 2.256],
                                                                [-3.384, 0.903],
                                                                [-6.092, 0],
                                                                [
                                                                    -3.836,
                                                                    -2.482
                                                                ],
                                                                [
                                                                    -2.256,
                                                                    -4.287
                                                                ],
                                                                [0, -8.348],
                                                                [4.738, -5.189],
                                                                [7.22, 0],
                                                                [4.287, 5.189],
                                                                [0, 0]
                                                            ],
                                                            "v": [
                                                                [24.706, 1.354],
                                                                [
                                                                    -13.876,
                                                                    1.354
                                                                ],
                                                                [
                                                                    -8.687,
                                                                    13.763
                                                                ],
                                                                [3.948, 18.501],
                                                                [
                                                                    23.803,
                                                                    11.733
                                                                ],
                                                                [
                                                                    23.803,
                                                                    22.337
                                                                ],
                                                                [
                                                                    13.876,
                                                                    27.075
                                                                ],
                                                                [2.369, 28.429],
                                                                [
                                                                    -12.297,
                                                                    24.593
                                                                ],
                                                                [
                                                                    -21.322,
                                                                    14.44
                                                                ],
                                                                [
                                                                    -24.706,
                                                                    -0.226
                                                                ],
                                                                [
                                                                    -17.712,
                                                                    -20.532
                                                                ],
                                                                [0.79, -28.429],
                                                                [
                                                                    18.163,
                                                                    -20.758
                                                                ],
                                                                [24.706, -0.451]
                                                            ],
                                                            "c": true
                                                        },
                                                        "ix": 2
                                                    },
                                                    "nm": "Path 1",
                                                    "mn": "ADBE Vector Shape - Group",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            -396.537, -37.005
                                                        ],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 1",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 1,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ind": 0,
                                                    "ty": "sh",
                                                    "ix": 1,
                                                    "ks": {
                                                        "a": 0,
                                                        "k": {
                                                            "i": [
                                                                [0.903, -4.287],
                                                                [0, 0],
                                                                [2.256, 2.256],
                                                                [3.836, 0],
                                                                [2.482, -2.482]
                                                            ],
                                                            "o": [
                                                                [0, 0],
                                                                [
                                                                    -0.226,
                                                                    -4.287
                                                                ],
                                                                [
                                                                    -2.256,
                                                                    -2.256
                                                                ],
                                                                [-3.836, 0],
                                                                [-2.482, 2.482]
                                                            ],
                                                            "v": [
                                                                [
                                                                    -13.763,
                                                                    6.769
                                                                ],
                                                                [13.763, 6.769],
                                                                [9.928, -3.159],
                                                                [0.677, -6.769],
                                                                [-8.799, -3.159]
                                                            ],
                                                            "c": true
                                                        },
                                                        "ix": 2
                                                    },
                                                    "nm": "Path 1",
                                                    "mn": "ADBE Vector Shape - Group",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            -396.424, -48.963
                                                        ],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 2",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 2,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "mm",
                                            "mm": 5,
                                            "nm": "Merge Paths 1",
                                            "mn": "ADBE Vector Filter - Merge",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [1, 1, 1, 1],
                                                "ix": 4
                                            },
                                            "o": { "a": 0, "k": 100, "ix": 5 },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [100, 100],
                                                "ix": 3
                                            },
                                            "r": { "a": 0, "k": 0, "ix": 6 },
                                            "o": { "a": 0, "k": 100, "ix": 7 },
                                            "sk": { "a": 0, "k": 0, "ix": 4 },
                                            "sa": { "a": 0, "k": 0, "ix": 5 },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 3",
                                    "np": 4,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 3,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ind": 0,
                                            "ty": "sh",
                                            "ix": 1,
                                            "ks": {
                                                "a": 0,
                                                "k": {
                                                    "i": [
                                                        [0, 0],
                                                        [0, 0],
                                                        [0, 0],
                                                        [-5.415, 0],
                                                        [-4.512, -4.061],
                                                        [0, 0],
                                                        [3.159, 0],
                                                        [2.482, -3.384],
                                                        [0, -4.738],
                                                        [0, 0],
                                                        [0, 0],
                                                        [0, 0]
                                                    ],
                                                    "o": [
                                                        [0, 0],
                                                        [0, 0],
                                                        [5.189, -8.348],
                                                        [4.061, 0],
                                                        [0, 0],
                                                        [-3.836, -3.61],
                                                        [-3.384, 0],
                                                        [-2.482, 3.384],
                                                        [0, 0],
                                                        [0, 0],
                                                        [0, 0],
                                                        [0, 0]
                                                    ],
                                                    "v": [
                                                        [-9.251, -26.962],
                                                        [-9.251, -14.327],
                                                        [-8.574, -15.23],
                                                        [7.22, -27.865],
                                                        [20.081, -21.773],
                                                        [14.44, -12.297],
                                                        [4.061, -17.712],
                                                        [-4.964, -12.748],
                                                        [-8.799, -0.79],
                                                        [-8.799, 27.865],
                                                        [-20.081, 27.865],
                                                        [-20.081, -26.962]
                                                    ],
                                                    "c": true
                                                },
                                                "ix": 2
                                            },
                                            "nm": "Path 1",
                                            "mn": "ADBE Vector Shape - Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [1, 1, 1, 1],
                                                "ix": 4
                                            },
                                            "o": { "a": 0, "k": 100, "ix": 5 },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [-442.903, -36.892],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [100, 100],
                                                "ix": 3
                                            },
                                            "r": { "a": 0, "k": 0, "ix": 6 },
                                            "o": { "a": 0, "k": 100, "ix": 7 },
                                            "sk": { "a": 0, "k": 0, "ix": 4 },
                                            "sa": { "a": 0, "k": 0, "ix": 5 },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 4",
                                    "np": 2,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 4,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "gr",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ind": 0,
                                                    "ty": "sh",
                                                    "ix": 1,
                                                    "ks": {
                                                        "a": 0,
                                                        "k": {
                                                            "i": [
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [
                                                                    -4.738,
                                                                    -4.061
                                                                ],
                                                                [0, -7.22],
                                                                [2.482, -3.836],
                                                                [4.287, -1.579],
                                                                [7.897, 0],
                                                                [0, 0],
                                                                [0, 0]
                                                            ],
                                                            "o": [
                                                                [0, 0],
                                                                [0, 0],
                                                                [7.897, 0],
                                                                [4.738, 4.287],
                                                                [0, 4.738],
                                                                [-2.482, 3.836],
                                                                [-4.287, 1.579],
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0]
                                                            ],
                                                            "v": [
                                                                [
                                                                    -26.173,
                                                                    41.628
                                                                ],
                                                                [
                                                                    -26.173,
                                                                    -41.628
                                                                ],
                                                                [
                                                                    0.226,
                                                                    -41.628
                                                                ],
                                                                [
                                                                    19.178,
                                                                    -35.31
                                                                ],
                                                                [
                                                                    26.173,
                                                                    -17.937
                                                                ],
                                                                [
                                                                    22.563,
                                                                    -5.077
                                                                ],
                                                                [12.635, 3.046],
                                                                [-5.415, 5.528],
                                                                [
                                                                    -14.214,
                                                                    5.528
                                                                ],
                                                                [
                                                                    -14.214,
                                                                    41.628
                                                                ]
                                                            ],
                                                            "c": true
                                                        },
                                                        "ix": 2
                                                    },
                                                    "nm": "Path 1",
                                                    "mn": "ADBE Vector Shape - Group",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            -496.827, -50.881
                                                        ],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 1",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 1,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "gr",
                                            "it": [
                                                {
                                                    "ind": 0,
                                                    "ty": "sh",
                                                    "ix": 1,
                                                    "ks": {
                                                        "a": 0,
                                                        "k": {
                                                            "i": [
                                                                [10.379, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [-2.708, 2.256],
                                                                [0, 4.061]
                                                            ],
                                                            "o": [
                                                                [0, 0],
                                                                [0, 0],
                                                                [0, 0],
                                                                [4.738, 0],
                                                                [2.708, -2.256],
                                                                [0, -8.574]
                                                            ],
                                                            "v": [
                                                                [
                                                                    -1.692,
                                                                    -12.973
                                                                ],
                                                                [
                                                                    -14.102,
                                                                    -12.973
                                                                ],
                                                                [
                                                                    -14.102,
                                                                    12.973
                                                                ],
                                                                [
                                                                    -1.015,
                                                                    12.973
                                                                ],
                                                                [10.266, 9.589],
                                                                [14.102, -0.113]
                                                            ],
                                                            "c": true
                                                        },
                                                        "ix": 2
                                                    },
                                                    "nm": "Path 1",
                                                    "mn": "ADBE Vector Shape - Group",
                                                    "hd": false
                                                },
                                                {
                                                    "ty": "tr",
                                                    "p": {
                                                        "a": 0,
                                                        "k": [-496.94, -68.931],
                                                        "ix": 2
                                                    },
                                                    "a": {
                                                        "a": 0,
                                                        "k": [0, 0],
                                                        "ix": 1
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [100, 100],
                                                        "ix": 3
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 6
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100,
                                                        "ix": 7
                                                    },
                                                    "sk": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 4
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0,
                                                        "ix": 5
                                                    },
                                                    "nm": "Transform"
                                                }
                                            ],
                                            "nm": "Group 2",
                                            "np": 1,
                                            "cix": 2,
                                            "bm": 0,
                                            "ix": 2,
                                            "mn": "ADBE Vector Group",
                                            "hd": false
                                        },
                                        {
                                            "ty": "mm",
                                            "mm": 5,
                                            "nm": "Merge Paths 1",
                                            "mn": "ADBE Vector Filter - Merge",
                                            "hd": false
                                        },
                                        {
                                            "ty": "fl",
                                            "c": {
                                                "a": 0,
                                                "k": [1, 1, 1, 1],
                                                "ix": 4
                                            },
                                            "o": { "a": 0, "k": 100, "ix": 5 },
                                            "r": 1,
                                            "bm": 0,
                                            "nm": "Fill 1",
                                            "mn": "ADBE Vector Graphic - Fill",
                                            "hd": false
                                        },
                                        {
                                            "ty": "tr",
                                            "p": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 2
                                            },
                                            "a": {
                                                "a": 0,
                                                "k": [0, 0],
                                                "ix": 1
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [100, 100],
                                                "ix": 3
                                            },
                                            "r": { "a": 0, "k": 0, "ix": 6 },
                                            "o": { "a": 0, "k": 100, "ix": 7 },
                                            "sk": { "a": 0, "k": 0, "ix": 4 },
                                            "sa": { "a": 0, "k": 0, "ix": 5 },
                                            "nm": "Transform"
                                        }
                                    ],
                                    "nm": "Group 5",
                                    "np": 4,
                                    "cix": 2,
                                    "bm": 0,
                                    "ix": 5,
                                    "mn": "ADBE Vector Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 10",
                            "np": 5,
                            "cix": 2,
                            "bm": 0,
                            "ix": 10,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 10,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 4500,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Ellipse 1",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 0,
                            "s": [169.776]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 394,
                            "s": [195.776]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 988,
                            "s": [222.776]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 1468,
                            "s": [172.776]
                        },
                        { "t": 3000, "s": [169.776] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 0,
                            "s": [841.037, 1770.936, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 315,
                            "s": [765.037, 1786.936, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1622,
                            "s": [699.037, 2512.936, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 3000, "s": [841.037, 1770.936, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [55, 55, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": { "a": 0, "k": [4505.021, 2954.223], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "gs",
                            "o": { "a": 0, "k": 100, "ix": 9 },
                            "w": { "a": 0, "k": 5, "ix": 10 },
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 0.969, 0.808, 0.333, 0.77, 0.984,
                                        0.904, 0.667, 1, 1, 1, 1, 0, 0.15, 0.77,
                                        0.075, 1, 0
                                    ],
                                    "ix": 8
                                }
                            },
                            "s": {
                                "a": 0,
                                "k": [1517.433, -1264.161],
                                "ix": 4
                            },
                            "e": { "a": 0, "k": [-1518.621, 1263.26], "ix": 5 },
                            "t": 1,
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "ml2": { "a": 0, "k": 10, "ix": 13 },
                            "bm": 0,
                            "nm": "Gradient Stroke 1",
                            "mn": "ADBE Vector Graphic - G-Stroke",
                            "hd": false
                        },
                        {
                            "ty": "gf",
                            "o": { "a": 0, "k": 100, "ix": 10 },
                            "r": 1,
                            "bm": 0,
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0.002, 0.969, 0.808, 0.333, 0.771,
                                        0.984, 0.904, 0.667, 1, 1, 1, 1, 0.002,
                                        0.15, 0.771, 0.075, 1, 0
                                    ],
                                    "ix": 9
                                }
                            },
                            "s": { "a": 0, "k": [-579.151, 1491.402], "ix": 5 },
                            "e": { "a": 0, "k": [579.653, -1492.519], "ix": 6 },
                            "t": 1,
                            "nm": "Gradient Fill 1",
                            "mn": "ADBE Vector Graphic - G-Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 4500,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Ellipse",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 0,
                            "s": [258.498]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 339,
                            "s": [282.498]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 1852,
                            "s": [265.498]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 2469,
                            "s": [312.498]
                        },
                        { "t": 2990, "s": [258.498] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 0,
                            "s": [611.253, 1771.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 240,
                            "s": [557.253, 1755.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1156,
                            "s": [477.253, 2847.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1917,
                            "s": [709.253, 1779.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 2414,
                            "s": [637.253, 2527.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 2990, "s": [611.253, 1771.165, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [70, 70, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": { "a": 0, "k": [2666.901, 4967.943], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "gs",
                            "o": { "a": 0, "k": 100, "ix": 9 },
                            "w": { "a": 0, "k": 5, "ix": 10 },
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 0.969, 0.808, 0.333, 0.77, 0.984,
                                        0.904, 0.667, 1, 1, 1, 1, 0, 0.15, 0.77,
                                        0.075, 1, 0
                                    ],
                                    "ix": 8
                                }
                            },
                            "s": { "a": 0, "k": [1355.881, 202.972], "ix": 4 },
                            "e": { "a": 0, "k": [-1357.609, -202.64], "ix": 5 },
                            "t": 1,
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "ml2": { "a": 0, "k": 10, "ix": 13 },
                            "bm": 0,
                            "nm": "Gradient Stroke 1",
                            "mn": "ADBE Vector Graphic - G-Stroke",
                            "hd": false
                        },
                        {
                            "ty": "gf",
                            "o": { "a": 0, "k": 100, "ix": 10 },
                            "r": 1,
                            "bm": 0,
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0.002, 0.969, 0.808, 0.333, 0.771,
                                        0.984, 0.904, 0.667, 1, 1, 1, 1, 0.002,
                                        0.15, 0.771, 0.075, 1, 0
                                    ],
                                    "ix": 9
                                }
                            },
                            "s": { "a": 0, "k": [864.744, 2197.741], "ix": 5 },
                            "e": {
                                "a": 0,
                                "k": [-867.024, -2198.973],
                                "ix": 6
                            },
                            "t": 1,
                            "nm": "Gradient Fill 1",
                            "mn": "ADBE Vector Graphic - G-Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 4500,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Black BG",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [540, 960, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [559.75, 1218.25, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-559.5, 1218],
                                        [559.5, 1218],
                                        [559.5, -1218],
                                        [-559.5, -1218]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [559.75, 1218.25], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 3088,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        }
    ],
    "markers": [],
    "props": {}
}
